import { RANGE_SCALE } from "./myDashboardConstants";

/* Deterministic pseudo-random so numbers don't jitter on every re-render */
export function seeded(seed) {
  let t = seed % 2147483647;
  if (t <= 0) t += 2147483646;
  return () => {
    t = (t * 16807) % 2147483647;
    return (t - 1) / 2147483646;
  };
}
export function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h || 1;
}
/** Scale a base ("This Month") number to any range with slight, stable noise */
export function scaleTo(base, range, key = "") {
  const rnd = seeded(hashStr(key + range));
  const jitter = 0.92 + rnd() * 0.16;
  return Math.round(base * RANGE_SCALE[range] * jitter);
}

export const formatIndianCurrency = (v) => {
  const num = Number(v) || 0;
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  if (num >= 1000) return `₹${(num / 1000).toFixed(1)} K`;
  return `₹${num}`;
};

export function ownerInitials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
